import { RouteConfig } from 'vue-router';
import MswUserGroupsTab from './user-groups-tab.vue';

const userGroupTab: RouteConfig = {
  path: 'user-groups',
  component: MswUserGroupsTab,
};

export function getDefaultParams() {
  return {};
}

export default userGroupTab;
